import "./App.css"
import "rc-slider/assets/index.css"

import { useState } from "react"
import { Flex, Box, Text } from "rebass"
import DataSlider from "./DataSlider.js"

const DataSum = ({ mbs, fontSize, fontSizeSm }) => {
  function round2(r) {
    return Math.round((r + Number.EPSILON) * 100) / 100
  }

  return (
    <Box sx={{ textAlign: "left" }} pl={5}>
      <Text fontSize={fontSize}>{`${round2(mbs / 1024)}GB /mo`}</Text>
      {mbs < 1024 && (
        <Text fontSize={fontSizeSm}>{`(${round2(mbs)}MB /mo)`}</Text>
      )}
    </Box>
  )
}

const TextLabel = ({ text, desc }) => (
  <Box sx={{ textAlign: "left", flexGrow: 1 }} pr={0} mr={0} pt={0} mt={0}>
    <Text mb={1} fontSize={17}>
      {text}
    </Text>
    <Text mb={1} fontSize={12}>
      {desc}
    </Text>
  </Box>
)

const DataSection = ({
  text,
  desc,
  numSteps,
  scaleFactor,
  mbsPerUnit,
  setTotal,
  total,
  dataKey,
  ...props
}) => (
  <Flex flexDirection="column" bg="#f8f8f8" mb={2} p={2}>
    <Flex alignItems="stretch">
      <TextLabel text={text} desc={desc} />
      <DataSum mbs={total[dataKey]} fontSize={14} fontSizeSm={11} />
    </Flex>
    <DataSlider
      numSteps={numSteps}
      scaleFactor={scaleFactor}
      mbsPerUnit={mbsPerUnit}
      setTotal={setTotal}
      total={total}
      dataKey={dataKey}
      {...props}
    />
  </Flex>
)

function App() {
  const [total, setTotal] = useState({
    email: 0,
    website: 0,
    video: 0,
    hdvideo: 0,
    audio: 0,
    voip: 0,
    videocall: 0,
  })

  function sumTotal() {
    return Object.values(total).reduce((el, acc) => el + acc)
  }

  function heightLevel() {
    let height = sumTotal() / 1024 / 10
    return height > 0 && height < 0.5 ? 0.5 : height
  }

  return (
    <div className="App">
      <Flex flexDirection={["column", "row"]} justifyContent="center">
        <Flex flexDirection="column" bg="#d3d3d3" p={2} pb={0} mr={1}>
          <DataSection
            text="Email"
            desc="How many emails do you send and receive per day?"
            numSteps={4}
            scaleFactor={20}
            mbsPerUnit={75 / 1024}
            setTotal={setTotal}
            total={total}
            dataKey="email"
          />
          <DataSection
            text="Websites"
            desc="How many web pages do you visit per day?"
            numSteps={4}
            scaleFactor={20}
            mbsPerUnit={1.6}
            setTotal={setTotal}
            total={total}
            dataKey="website"
          />
          <DataSection
            text="Video Streaming"
            desc="How many minutes of video do you stream per day?"
            numSteps={5}
            scaleFactor={30}
            mbsPerUnit={500 / 60}
            setTotal={setTotal}
            total={total}
            dataKey="video"
            time
          />
          <DataSection
            text="HD Video Streaming"
            desc="How many minutes of video do you stream per day?"
            numSteps={5}
            scaleFactor={30}
            mbsPerUnit={(3 * 1024) / 60}
            setTotal={setTotal}
            total={total}
            dataKey="hdvideo"
            time
          />
          <DataSection
            text="Music Streaming"
            desc="How many minutes of audio do you stream per day?"
            numSteps={5}
            scaleFactor={30}
            mbsPerUnit={51 / 60}
            setTotal={setTotal}
            total={total}
            dataKey="audio"
            time
          />
          <DataSection
            text="Internet Phone Calls (VoIP)"
            desc="How many minutes of VoIP calls do you make per day?"
            numSteps={5}
            scaleFactor={30}
            mbsPerUnit={67 / 60}
            setTotal={setTotal}
            total={total}
            dataKey="voip"
            time
          />
          <DataSection
            text="Video Calls & Video Conferncing"
            desc="How many minutes of video calls do you make per day?"
            numSteps={5}
            scaleFactor={30}
            mbsPerUnit={254 / 60}
            setTotal={setTotal}
            total={total}
            dataKey="videocall"
            time
          />
        </Flex>

        <Flex
          flexDirection="column"
          bg="#d3d3d3"
          p={2}
          sx={{ maxHeight: "75vh" }}
        >
          <Flex bg="#f8f8f8" mb={2} p={2}>
            <Text>Total per month:</Text>
            <DataSum mbs={sumTotal()} fontSize={17} fontSizeSm={13} />
          </Flex>
          <Flex
            bg="#f8f8f8"
            flexDirection="column"
            justifyContent="flex-end"
            sx={{ textAlign: "left", flexGrow: 1, flexBasis: "200px" }}
          >
            <Flex
              sx={{
                textAlign: "left",
                height: `${heightLevel()}%`,
              }}
              bg="#8AFF8A"
            ></Flex>
          </Flex>
        </Flex>
      </Flex>
    </div>
  )
}

export default App
